module.exports = __webpack_public_path__ + "static/media/RTI - PDF.976d1efc.pdf";